export const verifyCredentialsBulkActionType = 'verifyCredentials';
